import { Reveal } from '@/components/animation/reveal'

interface PageHeroProps {
    titleTop: string
    titleBottom: string
    detail?: string
}

// Shared page hero ("Selected / Work" style) used by the projects, blog,
// shop and contact pages.
export function PageHero({ titleTop, titleBottom, detail }: PageHeroProps) {
    return (
        <div className='section'>
            <div className='container main-hero-container'>
                <Reveal mode='load' delay={0.15} innerClassName='perspective-load1'>
                    <h1 className='hero-text'>{titleTop}</h1>
                </Reveal>
                <div className='page-hero-content-with-right-detail'>
                    <Reveal mode='load' delay={0.3} innerClassName='perspective-load2'>
                        <h1 className='hero-text'>{titleBottom}</h1>
                    </Reveal>
                    {detail ? (
                        <div className='content'>
                            <Reveal mode='load' delay={0.45} innerClassName='perspective-load4'>
                                <div>{detail}</div>
                            </Reveal>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
